// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import BaseStateSprite from "../../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { SettleLawsuitKind } from "../../../../define/SettleLawsuitKind";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

/** 自己说话背景和文字位置差 */
const c_selfTalkSpaceY = 45;
/** 五官资源路径 */
const c_featuresPath = 'res/main/';
@ccclass
export default class SettleLawsuitMainSelectSuspects extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	peopleList: cc.Node = null;

    @property({ type: cc.Label, displayName:'' })
	labelTalkHint: cc.Label = null;
    
    @property({ type: cc.Node, displayName:'' })
	nodeHint: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
    sprHintDialog: cc.Node = null;

    @property({ type: cc.Sprite, displayName:'' })
	sprHair: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprFeature: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprLip: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprNose: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprEyebrow: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprEye: cc.Sprite = null;

	@property({ type: BaseStateSprite, displayName:'' })
	sprHead: BaseStateSprite = null;
    // LIFE-CYCLE CALLBACKS:

    /** 最小高度 */
    private minTalkHeight = 0;
    private csvInfo: any = null;
    // onLoad () {}

    start () {
        this.minTalkHeight = this.sprHintDialog.height;
        this.initLayer();
    }

    initLayer() {
        this.csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEGAL_CASE_MAIN_ATTRIBUTE);
        if (!this.csvInfo) {
            console.error(`数据获取失败`);
            return;
        }
        
        this.showHint();
        this.showMadeHead();
        this.showSuspects();
    }

    showSuspects() {
        let csvMain = this._carryData.csvInfo;
        this.peopleList.children.forEach((v, i)=> {
            let suspects_talk = csvMain['suspects_talk' + (i+1)];
            let suspects_head = csvMain['suspects_head' + (i+1)];
            let sprHead = v.getChildByName('sprHead').getComponent(cc.Sprite);
            let labelTalk = v.getChildByName('nodeTalk').getChildByName('labelTalk').getComponent(cc.Label);
            this.loadIcon(sprHead, `res/main/suspects/${suspects_head}`);
            labelTalk.string = suspects_talk;
        });
    }

    showMadeHead() {
        let csvInfo = this.csvInfo;
        let title = csvInfo.title;
        let featuresArrIndex = this._carryData.featuresArrIndex;
        let featuresArrData = this._carryData.featuresArrData;

        let csvMain = this._carryData.csvInfo;
        let sexType = csvMain.sex;
        let bHair = csvMain.is_hair == GeneralKind.EnableState.ENABLED;
        this.sprHead.setFill(sexType != SettleLawsuitKind.SexType.MEN);
        if (!bHair) {
            let defaultHair = csvMain.default_hair;
            this.loadSprite(this.sprHair, defaultHair);
        }
        
        let FeaturesType = SettleLawsuitKind.FeaturesType;
        let arr = [this.sprEye, this.sprEyebrow, this.sprNose, this.sprLip, this.sprFeature];
        for (let i in FeaturesType) {
            if (!isNaN(Number(i))) {
                continue;
            }
            let typeId = FeaturesType[i];
            let idx = featuresArrIndex[typeId];
            let info = featuresArrData[typeId][idx];
            this.loadSprite(arr[Number(typeId) - 1], info[title.icon]);
        }
    }

    async loadIcon(sprNode: cc.Sprite, spPath: string) {
        if(spPath && spPath != ""){
            let bundle = await getOneBundle( BUNDLE_SMALL_NAME.settleLawsuitBundle );
            bundle.load(
                spPath
                , cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log("加载图片失败",err);
                    }else{
                        if(sprNode && sprNode.isValid){
                            sprNode.spriteFrame = spr;
                        }
                    }
                }
            );
        }
    }

    async loadSprite(sprite: cc.Sprite, path: string) {
        this.loadIcon(sprite, c_featuresPath + path);
    }

    showHint() {
        let remind_text = this._carryData.csvInfo.both_talk;
        this.nodeHint.active = false;
        if (utilsModel.isValidNumberValue(remind_text)) {
            this.nodeHint.active = true;
            this.labelTalkHint.string = remind_text;
            utilsView.refreshLabelUI(this.labelTalkHint);

            let height = this.labelTalkHint.node.height;
            height = Math.max(height + c_selfTalkSpaceY, this.minTalkHeight);
            this.sprHintDialog.height = height;
            this.labelTalkHint.node.getComponent(cc.Widget).updateAlignment();
        }
    }

    onClickSuspects(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        let idx = Number(data);
        let bWin = this._carryData.csvInfo.answer == (idx + 1);
        this._carryData.parent.showResultUI(bWin);
    }   

    // update (dt) {}
}
